// A passage based question is a container: its statement (the paragraph) is shown
// once and what actually gets rendered as questions are its sub-questions.
//
// Shared by the on-screen test report (TestReport.vue) and the downloadable one
// (ReportGenerators/TestReportGenerator.vue) so the two can never disagree on how
// a passage is unwrapped or numbered.
export const passageQuestion = {
  methods: {
    isPassageQuestion(question) {
      return question?.questionType === "PASSAGE_BASED";
    },
    // A plain-text passage carries its paragraph breaks as newlines rather than
    // markup, so it has to be rendered with whitespace preserved. Used by the
    // passage statement in both reports - removing it breaks their render.
    hasHtmlMarkup(statement) {
      return /<[a-z][\s\S]*>/i.test(statement || "");
    },
    // A passage based question is only a container - what gets rendered as questions are
    // its sub-questions. Every other question type renders as itself.
    questionsToRender(question) {
      return this.isPassageQuestion(question) ? question?.subQuestions || [] : [question];
    },
    // The last sub-question drops its own divider - the group's closing line takes its place.
    isLastSubQuestion(question, subQuestionIndex) {
      return this.isPassageQuestion(question) && subQuestionIndex === this.questionsToRender(question).length - 1;
    },
    // Sub-questions are numbered after their parent, so the second sub-question of the
    // 10th question reads as 10.2
    questionLabel(questionIndex, subQuestionIndex, question) {
      return this.isPassageQuestion(question)
        ? `${questionIndex + 1}.${subQuestionIndex + 1}`
        : `${questionIndex + 1}`;
    },
  },
};
